var React = require('react');

function Mapnew (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.579 4.1C6.63 4.1 4.23 6.44 4.23 9.315c0 2.875 2.4 5.214 5.348 5.214s5.347-2.34 5.347-5.214c0-2.875-2.399-5.213-5.347-5.213zm0 8.69c-1.966 0-3.565-1.56-3.565-3.476s1.599-3.476 3.565-3.476c1.965 0 3.564 1.56 3.564 3.476 0 1.917-1.599 3.476-3.564 3.476zm0 11.835C1.819 13.685.667 12.817.667 9.315c0-2.322.927-4.504 2.61-6.145A8.97 8.97 0 019.579.625 8.97 8.97 0 0115.88 3.17c1.684 1.641 2.61 3.823 2.61 6.144 0 3.502-1.152 4.37-8.911 15.311z","fill":"#1F74AC","fillRule":"nonzero"}));
}

Mapnew.defaultProps = {"width":"19","height":"25","viewBox":"0 0 19 25"};

module.exports = Mapnew;

Mapnew.default = Mapnew;
